// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"168":"79786a1f","478":"a6c3cb6e","530":"963a1d86","613":"2189b4b7","728":"612e7324","823":"0a40928a"}[chunkId] + ".css";
};